export const PhoneTelephone = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.9961 7.68583C17.7227 7.68583 18.3921 8.07985 18.7448 8.71509L21.1912 13.1219C21.5115 13.6989 21.5266 14.3968 21.2314 14.9871L18.8746 19.7008C18.8746 19.7008 19.5576 23.2122 22.416 26.0706C25.2744 28.929 28.7741 29.6002 28.7741 29.6002L33.487 27.2438C34.0777 26.9484 34.7761 26.9637 35.3533 27.2846L39.7726 29.7416C40.4072 30.0945 40.8008 30.7635 40.8008 31.4896L40.8008 36.5631C40.8008 39.1468 38.4009 41.0129 35.9528 40.1868C30.9249 38.4903 23.1202 35.2601 18.1734 30.3132C13.2265 25.3664 9.99631 17.5617 8.29977 12.5338C7.47375 10.0857 9.33984 7.68583 11.9235 7.68583L16.9961 7.68583Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
  </svg>
);

export const EmptyStateIcon = (props) => (
  <svg
    className="MuiSvgIcon-root"
    focusable="false"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <path
      fill={props.color}
      d="M22.73 22.73L2.77 2.77 2 2l-.73-.73L0 2.54l4.39 4.39 2.21 4.66-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h7.46l1.38 1.38c-.5.36-.83.95-.83 1.62 0 1.1.89 2 1.99 2 .67 0 1.26-.33 1.62-.84L21.46 24l1.27-1.27zM7.42 15c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h2.36l2 2H7.42zm8.13-2c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H6.54l9.01 9zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2z"
    ></path>
  </svg>
);

export const SettingIcon = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.2838 43.1713C14.9327 42.1736 11.9498 40.3213 9.58787 37.867C10.469 36.8227 11 35.4734 11 34.0001C11 30.6864 8.31371 28.0001 5 28.0001C4.79955 28.0001 4.60139 28.01 4.40599 28.0292C4.13979 26.7277 4 25.3803 4 24.0001C4 21.9095 4.32077 19.8938 4.91579 17.9995C4.94381 17.9999 4.97188 18.0001 5 18.0001C8.31371 18.0001 11 15.3138 11 12.0001C11 11.0488 10.7786 10.1493 10.3846 9.35011C12.6975 7.1995 15.5205 5.59002 18.6521 4.72314C19.6444 6.66819 21.6667 8.00013 24 8.00013C26.3333 8.00013 28.3556 6.66819 29.3479 4.72314C32.4795 5.59002 35.3025 7.1995 37.6154 9.35011C37.2214 10.1493 37 11.0488 37 12.0001C37 15.3138 39.6863 18.0001 43 18.0001C43.0281 18.0001 43.0562 17.9999 43.0842 17.9995C43.6792 19.8938 44 21.9095 44 24.0001C44 25.3803 43.8602 26.7277 43.594 28.0292C43.3986 28.01 43.2005 28.0001 43 28.0001C39.6863 28.0001 37 30.6864 37 34.0001C37 35.4734 37.531 36.8227 38.4121 37.867C36.0502 40.3213 33.0673 42.1736 29.7162 43.1713C28.9428 40.752 26.676 39.0001 24 39.0001C21.324 39.0001 19.0572 40.752 18.2838 43.1713Z"
      fill="none"
      stroke={props?.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      d="M24 31C27.866 31 31 27.866 31 24C31 20.134 27.866 17 24 17C20.134 17 17 20.134 17 24C17 27.866 20.134 31 24 31Z"
      fill="none"
      stroke={props?.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
  </svg>
);

export const Rules = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 44L21 36"
      stroke={props?.color}
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M42 44V12H26L27 20L28 28L29 36L22 44H42Z"
      fill="none"
      stroke={props?.color}
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M28 28H33"
      stroke={props?.color}
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M27 20H33"
      stroke={props?.color}
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6 4H25L26 12L27 20L28 28L29 36H21H6V4Z"
      fill="none"
      stroke={props?.color}
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 12H19"
      stroke={props?.color}
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 20H20"
      stroke={props?.color}
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 28H21"
      stroke={props?.color}
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const Trade = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.4915 8.61865H12.9187C13.3965 8.61865 13.8547 8.80844 14.1925 9.14626C14.5303 9.48409 14.7201 9.94228 14.7201 10.42V10.42C14.7201 10.8978 14.5303 11.356 14.1925 11.6938C13.8547 12.0316 13.3965 12.2214 12.9187 12.2214H10.481V9.95194"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M13.3184 16.3936H10.4915V12.2202H13.3184C13.5926 12.2202 13.8642 12.2742 14.1175 12.3792C14.3708 12.4841 14.601 12.6379 14.7949 12.8318C14.9888 13.0257 15.1426 13.2559 15.2475 13.5092C15.3524 13.7625 15.4065 14.034 15.4065 14.3082V14.3082C15.4058 14.8616 15.1855 15.392 14.794 15.783C14.4025 16.174 13.8718 16.3936 13.3184 16.3936V16.3936Z"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M10.4914 8.61865H9.59204"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M10.4914 16.3945H9.59204"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M11.4355 7.80811V8.61807"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M13.0898 7.80811V8.61807"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M11.4355 16.3945V17.2071"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M13.0896 16.3945V17.2071"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M18.3517 8.05299C19.4923 9.54342 20.0207 11.4131 19.829 13.28C19.6373 15.147 18.7399 16.8703 17.3202 18.0978C15.9006 19.3253 14.0658 19.9644 12.1907 19.8845C10.3157 19.8046 8.54187 19.0118 7.23178 17.6679C5.92168 16.3241 5.17416 14.5307 5.14195 12.6542C5.10975 10.7778 5.79529 8.95979 7.05849 7.57179C8.3217 6.18379 10.0672 5.33053 11.9385 5.18633C13.8097 5.04214 15.6653 5.6179 17.1263 6.79597"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M16.6661 20.8339C21.2688 18.533 23.1348 12.9366 20.8339 8.33386C18.5331 3.73115 12.9367 1.86512 8.33396 4.16597C3.73125 6.46682 1.8652 12.0633 4.16605 16.666C6.4669 21.2687 12.0634 23.1347 16.6661 20.8339Z"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const Home = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 18V42H39V18L24 6L9 18Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 29V42H29V29H19Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      d="M9 42H39"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
    />
  </svg>
);

export const Mail = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 39H44V24V9H24H4V24V39Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      d="M4 9L24 24L44 9"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24 9H4V24"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M44 24V9H24"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const KeyOne = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#icon-2ed2985a7770af78)">
      <circle
        cx="15"
        cy="33"
        r="8"
        fill="none"
        stroke={props.color}
        strokeWidth="3"
      />
      <path
        d="M29 16L35.5 22"
        stroke={props.color}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 26L37 7"
        stroke={props.color}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35 11L42 17.5"
        stroke={props.color}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="icon-2ed2985a7770af78">
        <rect width="48" height="48" fill={props.color} />
      </clipPath>
    </defs>
  </svg>
);

export const ActivitySource = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M42 5H6V13H42V5Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      d="M42 20H6V28H42V20Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      d="M42 35H6V43H42V35Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
  </svg>
);

export const More = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="24" r="3" fill={props.color} />
    <circle cx="24" cy="24" r="3" fill={props.color} />
    <circle cx="36" cy="24" r="3" fill={props.color} />
  </svg>
);

export const Protect = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 9.25564L24.0086 4L42 9.25564V20.0337C42 31.3622 34.7502 41.4194 24.0026 45.0005C13.2521 41.4195 6 31.36 6 20.0287V9.25564Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      d="M15 23L22 30L34 18"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Message = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M44.0001 24C44.0001 35.0457 35.0458 44 24.0001 44C18.0266 44 4.00006 44 4.00006 44C4.00006 44 4.00006 29.0722 4.00006 24C4.00006 12.9543 12.9544 4 24.0001 4C35.0458 4 44.0001 12.9543 44.0001 24Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 18L32 18"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 26H32"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 34H24"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Remind = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24 4C16.268 4 10 10.268 10 18V38H38V18C38 10.268 31.732 4 24 4Z"
      fill="none"
    />
    <path
      d="M10 38V18C10 10.268 16.268 4 24 4C31.732 4 38 10.268 38 18V38M4 38H44"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24 44C26.7614 44 29 41.7614 29 39V38H19V39C19 41.7614 21.2386 44 24 44Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Link = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.7073 9.56521L9.85801 24.4145C6.34329 27.9292 6.34329 33.6277 9.85801 37.1424V37.1424C13.3727 40.6571 19.0712 40.6571 22.5859 37.1424L40.2636 19.4647C42.6067 17.1216 42.6067 13.3226 40.2636 10.9794V10.9794C37.9205 8.63628 34.1215 8.63628 31.7783 10.9794L14.1007 28.6571C12.9291 29.8287 12.9291 31.7282 14.1007 32.8997V32.8997C15.2722 34.0713 17.1717 34.0713 18.3433 32.8997L33.1925 18.0505"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Search = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 38C30.3888 38 38 30.3888 38 21C38 11.6112 30.3888 4 21 4C11.6112 4 4 11.6112 4 21C4 30.3888 11.6112 38 21 38Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      d="M26.657 14.3431C25.2093 12.8954 23.2093 12 21.0001 12C18.791 12 16.791 12.8954 15.3433 14.3431"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33.2216 33.2217L41.7069 41.707"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WhatsAppIcon = (props) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.4449 14.0602C17.1895 13.9289 15.9168 13.3055 15.6801 13.2211C15.4434 13.132 15.2699 13.0898 15.0988 13.3523C14.9254 13.6125 14.4332 14.1914 14.2785 14.3672C14.1285 14.5406 13.9762 14.5617 13.7207 14.4328C12.202 13.6734 11.2059 13.0781 10.2051 11.3602C9.94023 10.9031 10.4699 10.9359 10.9645 9.94922C11.0488 9.77578 11.0066 9.62813 10.941 9.49688C10.8754 9.36563 10.3598 8.09531 10.1441 7.57734C9.93555 7.07344 9.71992 7.14375 9.56289 7.13437C9.41289 7.125 9.2418 7.125 9.06836 7.125C8.89492 7.125 8.61602 7.19063 8.3793 7.44609C8.14258 7.70625 7.47461 8.33203 7.47461 9.60234C7.47461 10.8727 8.40039 12.1031 8.52695 12.2766C8.6582 12.45 10.348 15.0563 12.9426 16.1789C14.5832 16.8867 15.2254 16.9477 16.0457 16.8258C16.5449 16.7508 17.5738 16.2023 17.7871 15.5953C18.0004 14.9906 18.0004 14.4727 17.9371 14.3648C17.8738 14.25 17.7004 14.1844 17.4449 14.0602Z"
      fill={props.color}
    />
    <path
      d="M22.4064 7.93125C21.8767 6.67266 21.1174 5.54297 20.1494 4.57266C19.1814 3.60469 18.0517 2.84297 16.7908 2.31563C15.5017 1.77422 14.133 1.5 12.7221 1.5H12.6752C11.2549 1.50703 9.87909 1.78828 8.58534 2.34141C7.33612 2.87578 6.21581 3.63516 5.25721 4.60312C4.29862 5.57109 3.54628 6.69609 3.02596 7.95C2.4869 9.24844 2.21503 10.6289 2.22206 12.0492C2.22909 13.6758 2.61815 15.2906 3.34706 16.7344V20.2969C3.34706 20.8922 3.82987 21.375 4.42518 21.375H7.99003C9.43378 22.1039 11.0486 22.493 12.6752 22.5H12.7244C14.1283 22.5 15.49 22.2281 16.7721 21.6961C18.026 21.1734 19.1533 20.4234 20.1189 19.4648C21.0869 18.5063 21.8486 17.3859 22.3806 16.1367C22.9338 14.843 23.215 13.4672 23.2221 12.0469C23.2291 10.6195 22.9525 9.23438 22.4064 7.93125ZM18.865 18.1969C17.2221 19.8234 15.0424 20.7188 12.7221 20.7188H12.6822C11.2689 20.7117 9.86503 20.3602 8.62518 19.6992L8.42831 19.5938H5.12831V16.2938L5.02284 16.0969C4.3619 14.857 4.01034 13.4531 4.00331 12.0398C3.99393 9.70312 4.8869 7.50937 6.52518 5.85703C8.16112 4.20469 10.3478 3.29062 12.6846 3.28125H12.7244C13.8963 3.28125 15.033 3.50859 16.1041 3.95859C17.1494 4.39687 18.0869 5.02734 18.8932 5.83359C19.6971 6.6375 20.3299 7.57734 20.7682 8.62266C21.2228 9.70547 21.4502 10.8539 21.4455 12.0398C21.4314 14.3742 20.515 16.5609 18.865 18.1969Z"
      fill={props.color}
    />
  </svg>
);

export const EmailIcon = (props) => (
  <svg
    width={props.size || '18'}
    height={props.size || '19'}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.25 4H19.75C20.5801 3.99995 21.3788 4.31755 21.9822 4.88767C22.5856 5.45779 22.948 6.23719 22.995 7.066L23 7.25V16.75C23.0001 17.5801 22.6824 18.3788 22.1123 18.9822C21.5422 19.5856 20.7628 19.948 19.934 19.995L19.75 20H6.25C5.41986 20.0001 4.62117 19.6824 4.01777 19.1123C3.41437 18.5422 3.052 17.7628 3.005 16.934L3 16.75V7.25C2.99995 6.41986 3.31755 5.62117 3.88767 5.01777C4.45779 4.41437 5.23719 4.052 6.066 4.005L6.25 4H19.75H6.25ZM21.5 9.373L13.35 13.663C13.258 13.7116 13.1568 13.7405 13.053 13.7479C12.9492 13.7553 12.845 13.7411 12.747 13.706L12.651 13.664L4.5 9.374V16.75C4.50002 17.1892 4.66517 17.6123 4.96268 17.9354C5.26019 18.2585 5.6683 18.4579 6.106 18.494L6.25 18.5H19.75C20.1893 18.5 20.6126 18.3347 20.9357 18.037C21.2588 17.7392 21.4581 17.3309 21.494 16.893L21.5 16.75V9.373ZM19.75 5.5H6.25C5.81081 5.50002 5.38768 5.66517 5.06461 5.96268C4.74154 6.26019 4.54214 6.6683 4.506 7.106L4.5 7.25V7.679L13 12.152L21.5 7.678V7.25C21.5 6.81065 21.3347 6.38739 21.037 6.06429C20.7392 5.74119 20.3309 5.5419 19.893 5.506L19.75 5.5Z"
      strokeWidth="3"
      fill={props.color}
    />
  </svg>
);

export const TelegramIcon = (props) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.1534 3.26238C21.9986 3.12872 21.8104 3.03976 21.6089 3.00507C21.4073 2.97039 21.2002 2.99128 21.0096 3.06551L3.71277 9.86238C3.48798 9.95182 3.29802 10.1113 3.17105 10.3173C3.04408 10.5232 2.98688 10.7646 3.00793 11.0056C3.02898 11.2466 3.12716 11.4744 3.2879 11.6552C3.44864 11.836 3.66338 11.9601 3.90027 12.0093L8.59715 12.9561V18.7499C8.5943 18.9731 8.65903 19.1919 8.78285 19.3776C8.90667 19.5634 9.08377 19.7073 9.2909 19.7905C9.4311 19.8463 9.58063 19.8749 9.73152 19.8749C9.87797 19.875 10.023 19.8461 10.1582 19.7898C10.2934 19.7335 10.416 19.6509 10.519 19.5468L13.2003 16.8655L17.1565 20.3436C17.3593 20.5272 17.6237 20.6276 17.8971 20.6249C18.015 20.6246 18.1321 20.6056 18.244 20.5686C18.4283 20.5082 18.5941 20.4014 18.7254 20.2586C18.8567 20.1158 18.9492 19.9417 18.994 19.753L22.519 4.35926C22.5652 4.16049 22.5554 3.95284 22.4909 3.75925C22.4264 3.56567 22.3096 3.39371 22.1534 3.26238ZM3.75027 10.9405C3.73912 10.8593 3.75635 10.7766 3.79905 10.7066C3.84175 10.6366 3.9073 10.5834 3.98464 10.5561L19.8471 4.33113L8.88777 12.2436L4.05027 11.278C3.9697 11.2635 3.89634 11.2223 3.84194 11.1611C3.78755 11.0999 3.75527 11.0222 3.75027 10.9405ZM9.98465 19.0124C9.93371 19.0653 9.868 19.1017 9.79609 19.1167C9.72419 19.1318 9.64941 19.1248 9.58152 19.0968C9.51239 19.0688 9.45317 19.0209 9.41142 18.9591C9.36968 18.8973 9.3473 18.8245 9.34715 18.7499V13.4718L12.6378 16.3686L9.98465 19.0124ZM21.7878 4.19988L18.2628 19.5843C18.2487 19.6481 18.2178 19.7069 18.1733 19.7547C18.1288 19.8026 18.0723 19.8376 18.0096 19.8561C17.9491 19.8779 17.8838 19.8824 17.8209 19.8691C17.758 19.8559 17.7 19.8254 17.6534 19.7811L9.57215 12.6749L21.7315 3.89051C21.7622 3.9352 21.783 3.98586 21.7927 4.03918C21.8024 4.0925 21.8007 4.14727 21.7878 4.19988Z"
      strokeWidth="3"
      fill={props.color}
    />
  </svg>
);

export const InstagramIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      strokeWidth="3"
      d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"
      fill={props.color}
    />
  </svg>
);

export const ContactPhoneIcon = (props) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.24558 2.47911L8.38518 2.73831C7.61908 2.96935 6.93491 3.41442 6.41321 4.02116C5.89151 4.62789 5.554 5.37103 5.44038 6.16311C5.08398 8.64471 5.88078 11.5463 7.80198 14.8739C9.71838 18.1931 11.828 20.3315 14.15 21.2675C14.8961 21.5682 15.7128 21.6483 16.5031 21.4984C17.2933 21.3484 18.0239 20.9746 18.608 20.4215L19.2584 19.8047C19.6807 19.405 19.9436 18.8655 19.9981 18.2866C20.0526 17.7077 19.8951 17.1286 19.5548 16.6571L17.9276 14.4011C17.7076 14.0965 17.3978 13.8685 17.0417 13.7488C16.6855 13.6292 16.3008 13.6239 15.9416 13.7339L13.4804 14.4863L13.4168 14.4983C13.1456 14.5379 12.5192 13.9511 11.7392 12.5999C10.9232 11.1863 10.7552 10.3595 10.9796 10.1459L12.2312 8.97831C12.6889 8.55167 13.0015 7.99244 13.1253 7.37909C13.249 6.76575 13.1777 6.12904 12.9212 5.55831L12.1268 3.79311C11.8879 3.26192 11.464 2.83573 10.9341 2.59397C10.4043 2.35221 9.80454 2.31139 9.24678 2.47911H9.24558ZM11.0336 4.28511L11.8256 6.05031C11.9798 6.39259 12.023 6.77459 11.9489 7.14265C11.8749 7.5107 11.6874 7.84631 11.4128 8.10231L10.1576 9.27111C9.35478 10.0319 9.62118 11.3303 10.7012 13.1999C11.7164 14.9591 12.6428 15.8279 13.6388 15.6767L13.7876 15.6455L16.2932 14.8811C16.4129 14.8443 16.5412 14.846 16.66 14.8858C16.7788 14.9256 16.8822 15.0016 16.9556 15.1031L18.5828 17.3591C18.7532 17.5949 18.8321 17.8845 18.805 18.1741C18.7778 18.4637 18.6464 18.7335 18.4352 18.9335L17.7836 19.5503C17.3664 19.9451 16.8446 20.2119 16.2803 20.3189C15.7159 20.4259 15.1327 20.3686 14.6 20.1539C12.5624 19.3331 10.6364 17.3807 8.84238 14.2739C7.04358 11.1599 6.31518 8.51151 6.62838 6.33351C6.70946 5.76763 6.95053 5.23669 7.32321 4.80321C7.69589 4.36972 8.18466 4.05175 8.73198 3.88671L9.59238 3.62751C9.87133 3.54369 10.1712 3.56419 10.4362 3.68518C10.7011 3.80618 10.913 4.01941 11.0324 4.28511H11.0336Z"
      fill={props.color}
    />
  </svg>
);

export const Share = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28 6H42V20"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M42 29.4737V39C42 40.6569 40.6569 42 39 42H9C7.34315 42 6 40.6569 6 39V9C6 7.34315 7.34315 6 9 6L18 6"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.7998 22.1999L41.0998 6.8999"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PreviewCloseOne = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.85786 18C6.23858 21 4 24 4 24C4 24 12.9543 36 24 36C25.3699 36 26.7076 35.8154 28 35.4921M20.0318 12.5C21.3144 12.1816 22.6414 12 24 12C35.0457 12 44 24 44 24C44 24 41.7614 27 38.1421 30"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.3142 20.6211C19.4981 21.5109 19 22.6972 19 23.9998C19 26.7612 21.2386 28.9998 24 28.9998C25.3627 28.9998 26.5981 28.4546 27.5 27.5705"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M42 42L6 6"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PreviewOpen = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24 36C35.0457 36 44 24 44 24C44 24 35.0457 12 24 12C12.9543 12 4 24 4 24C4 24 12.9543 36 24 36Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      d="M24 29C26.7614 29 29 26.7614 29 24C29 21.2386 26.7614 19 24 19C21.2386 19 19 21.2386 19 24C19 26.7614 21.2386 29 24 29Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
  </svg>
);

export const MoreOne = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="24" cy="12" r="3" fill={props.color} />
    <circle cx="24" cy="24" r="3" fill={props.color} />
    <circle cx="24" cy="35" r="3" fill={props.color} />
  </svg>
);

export const HeadsetOne = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M36 32C40.4183 32 44 28.4183 44 24C44 19.5817 40.4183 16 36 16"
      fill="none"
    />
    <path
      d="M36 32V32C40.4183 32 44 28.4183 44 24C44 19.5817 40.4183 16 36 16"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      d="M12 16C7.58172 16 4 19.5817 4 24C4 28.4183 7.58172 32 12 32"
      fill="none"
    />
    <path
      d="M12 16C7.58172 16 4 19.5817 4 24C4 28.4183 7.58172 32 12 32V32"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      d="M12 32V31.5V29V24V16C12 9.37258 17.3726 4 24 4C30.6274 4 36 9.37258 36 16V32C36 38.6274 30.6274 44 24 44"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChartPie = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M44 24C44 35.0457 35.0457 44 24 44C12.9543 44 4 35.0457 4 24C4 12.9543 12.9543 4 24 4V24H44Z"
      fill="none"
      stroke={props.color}
      strokeWidth={props.stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M43.0844 18H30V4.91553C36.2202 6.86917 41.1308 11.7798 43.0844 18Z"
      fill="none"
      stroke={props.color}
      strokeWidth={props.stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SanaCashLogo = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="120"
    height="14.75"
    viewBox="0 0 928 114"
    fill="none"
  >
    <g clipPath="url(#a)">
      <mask
        id="b"
        width={928}
        height={114}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill={props.fill || '#ffffff'}
          color={props.fill || '#ffffff'}
          d="M927.5 0H.5v114h927V0Z"
        />
      </mask>
      <g mask="url(#b)">
        <mask
          id="c"
          width={928}
          height={114}
          x={0}
          y={0}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: 'luminance',
          }}
        >
          <path
            fill={props.fill || '#ffffff'}
            color={props.fill || '#ffffff'}
            d="M.5 0h927v114H.5V0Z"
          />
        </mask>
        <g mask="url(#c)">
          <path
            fill={props.fill || '#ffffff'}
            color={props.fill || '#ffffff'}
            d="m158.2 113.9 4.2-8.3c1.4-2.8 4.3-4.6 7.5-4.6h49l-44.5-87.3-48.7 95.6c-1.5 2.9-4.4 4.6-7.6 4.6h-9.7L163.3 6.2c2-3.9 6.1-6.4 10.5-6.4h8.5l58.1 114.1h-82.2Zm225.1 0 4.3-8.3c1.4-2.8 4.3-4.6 7.5-4.6h49l-44.5-87.3-48.7 95.6c-1.5 2.9-4.4 4.6-7.6 4.6h-9.7L388.5 6.2c2-3.9 6-6.4 10.5-6.4h8.5l58.1 114.1h-82.3Zm234.5 0 4.2-8.3c1.4-2.8 4.3-4.6 7.5-4.6h49.1L634 13.7l-48.7 95.6c-1.4 2.9-4.3 4.6-7.5 4.6H568L622.9 6.2c2-3.9 6.1-6.4 10.5-6.4h8.5L700 113.9h-82.2Zm-108.1 0c-31.5 0-57.1-25.6-57.1-57 0-31.5 25.6-57.1 57.1-57.1H559v6.4c0 3.6-2.9 6.5-6.5 6.5h-42.8c-24.4 0-44.2 19.8-44.2 44.2 0 24.3 19.8 44.1 44.2 44.1h42.8c3.6 0 6.5 2.9 6.5 6.5v6.4h-49.3ZM927.6-.2v114.1h-6.9c-3.6 0-6.6-3-6.6-6.7V56.1l-75.7-.1v51.2c0 3.7-3 6.7-6.7 6.7h-6.9V-.2h6.9c3.7 0 6.7 3 6.7 6.7v36.6l75.7.1V6.5c0-3.7 3-6.7 6.6-6.7h6.9ZM312.1 113.9l-72.8-98v40.7c0 3.7-3 6.7-6.7 6.7h-6.8V-.2h16.4l72.9 98.1V6.5c0-3.7 3-6.7 6.7-6.7h6.8v114.1h-16.5ZM108.7 84c-.5 7.9-3.9 15.1-9.2 20.5-5.7 5.8-13.7 9.5-22.5 9.5h-1.6c-1.4 0-4.1-.1-8.9-.1H2.4v-6.5c0-3.5 2.9-6.4 6.5-6.4h69.2c2.3-.2 4.5-.8 6.6-1.7 6.5-3 11-9.5 11-17.1 0-2.7-.5-5.2-1.6-7.5 1.8.733 3.667 1.667 5.6 2.8 3.9 2.2 6.4 4.1 8.2 5.8.267.2.533.433.8.7Z"
          />
          <path
            fill={props.color || '#09f'}
            color={props.fill || '#09f'}
            d="M107.7 75.3c-1.9-1.7-4.4-3.5-8.3-5.8-11.8-6.9-18.7-6.2-36.9-6.1H61l-21.7-.1h-7C14.8 63.3.5 49 .5 31.5S14.8-.3 32.3-.3c.333 0 .7.033 1.1.1h70.4v6.4c0 3.6-2.9 6.5-6.4 6.5H30.5l-.8.2c-9.2 1.3-16.2 9.3-16.2 18.6 0 9.4 7 17.4 16.2 18.6h.1l39.9.3 7 .1c15.1 0 27.8 10.6 31 24.8Z"
          />
          <path
            fill={props.fill || '#ffffff'}
            color={props.fill || '#ffffff'}
            d="M814.9 84c-.4 8-3.8 15.2-9.1 20.5-5.8 5.9-13.8 9.5-22.6 9.5h-1.6c-1.4 0-4 0-8.9-.1h-64.1v-6.4c0-3.6 2.9-6.5 6.5-6.5h69.3c2.3-.2 4.5-.7 6.5-1.7 6.6-2.9 11.1-9.5 11.1-17.1 0-2.7-.6-5.2-1.6-7.5 1.733.733 3.6 1.667 5.6 2.8 3.8 2.3 6.3 4.1 8.2 5.8l.7.7Z"
          />
          <path
            fill={props.color || '#09f'}
            color={props.fill || '#09f'}
            d="M814.2 75.3c-1.9-1.7-4.4-3.5-8.2-5.8-11.9-6.9-18.8-6.2-37-6.1h-1.4l-21.8-.1h-7C721.3 63.3 707 49 707 31.5S721.3-.3 738.8-.3c.333 0 .7.033 1.1.1h70.5v6.4c0 3.6-3 6.5-6.5 6.5H737l-.8.2C727 14.2 720 22.2 720 31.5c0 9.4 7 17.4 16.2 18.6h.1l39.9.3 7.1.1c15.1 0 27.7 10.6 30.9 24.8Z"
          />
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="a">
        <path
          fill={props.fill || '#ffffff'}
          color={props.fill || '#ffffff'}
          d="M0 0h928v114H0z"
        />
      </clipPath>
    </defs>
  </svg>
);

export const Sun = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.15039 9.15088L11.3778 11.3783"
      stroke={props.color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 24H6.15"
      stroke={props.color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.15039 38.8495L11.3778 36.6221"
      stroke={props.color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M38.8495 38.8495L36.6221 36.6221"
      stroke={props.color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M44.9996 24H41.8496"
      stroke={props.color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M38.8495 9.15088L36.6221 11.3783"
      stroke={props.color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24 3V6.15"
      stroke={props.color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24 36C30.6274 36 36 30.6274 36 24C36 17.3726 30.6274 12 24 12C17.3726 12 12 17.3726 12 24C12 30.6274 17.3726 36 24 36Z"
      fill={props.color}
      stroke={props.color}
      strokeWidth="2"
      stroke-linejoin="round"
    />
    <path
      d="M24 45.0001V41.8501"
      stroke={props.color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Moon = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28.0527 4.41085C22.5828 5.83695 18.5455 10.8106 18.5455 16.7273C18.5455 23.7564 24.2436 29.4545 31.2727 29.4545C37.1894 29.4545 42.1631 25.4172 43.5891 19.9473C43.8585 21.256 44 22.6115 44 24C44 35.0457 35.0457 44 24 44C12.9543 44 4 35.0457 4 24C4 12.9543 12.9543 4 24 4C25.3885 4 26.744 4.14149 28.0527 4.41085Z"
      fill={props.color}
      stroke={props.color}
      stroke-width="2"
      stroke-linejoin="round"
    />
  </svg>
);

export const Activity = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="11"
      y="4"
      width="26"
      height="40"
      rx="3"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
    />
    <path
      d="M22 10L26 10"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 38H28"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WithdrawIcon = (props) => (
  <svg
    width={props.width || '36'}
    height={props.height || '35'}
    viewBox="0 0 36 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.9093 8.67531L23.9093 8.67531V8.67803C23.9093 8.74618 23.8891 8.81279 23.8512 8.86944C23.8134 8.92609 23.7595 8.97025 23.6966 8.99633C23.6336 9.02241 23.5644 9.02923 23.4975 9.01594L23.4 9.50633L23.4975 9.01593C23.4307 9.00264 23.3693 8.96983 23.3211 8.92164L22.9676 9.27519L23.3211 8.92164C23.2729 8.87345 23.2401 8.81206 23.2268 8.74524C23.2135 8.67842 23.2204 8.60915 23.2464 8.54618C23.2725 8.48322 23.3167 8.42942 23.3733 8.39156C23.43 8.35371 23.4966 8.33351 23.5647 8.33352L23.5675 8.3335C23.6124 8.33326 23.657 8.34193 23.6986 8.35902C23.7401 8.3761 23.7779 8.40127 23.8097 8.43307C23.8415 8.46488 23.8667 8.50266 23.8837 8.54421C23.9008 8.58579 23.9095 8.63035 23.9093 8.67531ZM24.4093 8.67803C24.4093 8.84506 24.3597 9.00834 24.2669 9.14722C24.1741 9.2861 24.0422 9.39435 23.8879 9.45826L24.4093 8.67803Z"
      fill="#717781"
      stroke={props.color}
    />
    <path
      d="M12.8345 16.0188C12.8345 16.087 12.8143 16.1536 12.7765 16.2102C12.7386 16.2669 12.6848 16.3111 12.6219 16.3371C12.5589 16.3632 12.4897 16.37 12.4228 16.3567L12.3253 16.8471L12.4228 16.3567C12.356 16.3434 12.2946 16.3106 12.2464 16.2625L11.8929 16.616L12.2464 16.2625C12.1982 16.2143 12.1654 16.1529 12.1521 16.0861C12.1388 16.0192 12.1457 15.9499 12.1717 15.887C12.1978 15.824 12.242 15.7702 12.2986 15.7324C12.3553 15.6945 12.4219 15.6743 12.49 15.6743C12.5814 15.6743 12.669 15.7106 12.7336 15.7752C12.7982 15.8398 12.8345 15.9275 12.8345 16.0188Z"
      fill="#717781"
      stroke={props.color}
    />
    <path
      d="M14.7131 6.92535L23.4003 1L34.9999 8.42722L25.9475 14.5945"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M10.1208 10.0527L1 16.2657L12.5996 23.6929L20.7025 18.1693"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M17.6804 8.76965L23.4551 4.83008L29.2024 8.50945L25.2126 11.2302"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M10.7645 13.4805L6.79297 16.1829L12.5448 19.8623L18.1872 16.0186"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M1 19.6338L12.5996 27.0656L21.2548 21.1676"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M35.0001 11.8008L26.7603 17.4157"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M1 23.0083L12.5996 30.4401L20.9855 24.7247"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M35.0001 15.1743L26.7603 20.7893"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M1 26.3818L12.5996 33.8136L21.7296 27.5916"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M35.0001 18.5479L26.7603 24.1628"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M10.2579 10.1709L21.7205 17.5068V27.7187C21.7209 27.8214 21.7495 27.9221 21.8031 28.0098C21.8568 28.0974 21.9334 28.1687 22.0248 28.2158C22.1161 28.2628 22.2186 28.284 22.3211 28.2768C22.4237 28.2696 22.5222 28.2345 22.6062 28.1752L25.9569 25.8059C26.0311 25.7551 26.0918 25.687 26.134 25.6075C26.1761 25.5279 26.1983 25.4394 26.1988 25.3494V14.7587L13.9099 6.89323C13.7787 6.80588 13.6246 6.75928 13.4671 6.75928C13.3095 6.75928 13.1554 6.80588 13.0243 6.89323L10.2579 8.86073C10.1524 8.93435 10.0663 9.03236 10.0068 9.14641C9.94731 9.26046 9.91626 9.38718 9.91626 9.51581C9.91626 9.64443 9.94731 9.77116 10.0068 9.88521C10.0663 9.99926 10.1524 10.0973 10.2579 10.1709V10.1709Z"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const DepositIcon = (props) => (
  <svg
    width={props.width || '34'}
    height={props.height || '30'}
    viewBox="0 0 34 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M33 27.1738V1L1 1V27.1738L33 27.1738Z"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M30.523 23.7881H4.39062V4.39062H29.6096V7.29217"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M30.7396 7.29199H28.4839V10.5349H30.7396V7.29199Z"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M30.7396 17.6479H28.4839V20.8908H30.7396V17.6479Z"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M18.5614 12.532C18.8691 12.8406 19.0785 13.2335 19.163 13.6611C19.2476 14.0886 19.2035 14.5316 19.0364 14.9341C18.8693 15.3367 18.5867 15.6807 18.2243 15.9227C17.8618 16.1646 17.4357 16.2938 16.9999 16.2938C16.5641 16.2938 16.138 16.1646 15.7756 15.9227C15.4131 15.6807 15.1305 15.3367 14.9634 14.9341C14.7963 14.5316 14.7523 14.0886 14.8368 13.6611C14.9214 13.2335 15.1307 12.8406 15.4384 12.532C15.8527 12.1182 16.4143 11.8857 16.9999 11.8857C17.5855 11.8857 18.1471 12.1182 18.5614 12.532V12.532Z"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M14.5806 20.4527C13.6773 20.1129 12.8577 19.5827 12.1773 18.8982C11.2269 17.9472 10.5797 16.7359 10.3175 15.4173C10.0554 14.0987 10.19 12.7319 10.7045 11.4898C11.2189 10.2476 12.09 9.18589 13.2077 8.43872C14.3254 7.69155 15.6395 7.29249 16.984 7.29199"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M19.3366 7.70215C20.8395 8.24951 22.1013 9.30918 22.9002 10.6948C23.6991 12.0805 23.984 13.7034 23.7047 15.2783C23.4254 16.8533 22.5999 18.2793 21.3732 19.3057C20.1465 20.3322 18.5973 20.8934 16.9978 20.8906"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M12.3572 9.44629L13.0122 10.1059"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M20.9878 18.0771L21.6428 18.7322"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M21.6428 9.44629L20.9878 10.1059"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M13.0122 18.0771L12.3572 18.7322"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M16.9978 7.52734V8.45455"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M16.9978 19.7285V20.6557"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M23.5666 14.0918H22.6394"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M11.3608 14.0918H10.4336"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M7.77652 29.2171H4.39062V27.1782H7.77652"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M29.6095 29.2171H26.2236V27.1782H29.6095"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M29.6094 13.0215V17.6483"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const BankCard = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 10C4 8.89543 4.89543 8 6 8H42C43.1046 8 44 8.89543 44 10V38C44 39.1046 43.1046 40 42 40H6C4.89543 40 4 39.1046 4 38V10Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      d="M4 16H44"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27 32H36"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M44 10V26"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 10V26"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Peoples = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 20C22.866 20 26 16.866 26 13C26 9.13401 22.866 6 19 6C15.134 6 12 9.13401 12 13C12 16.866 15.134 20 19 20Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32.6077 7C34.6405 8.2249 36.0001 10.4537 36.0001 13C36.0001 15.5463 34.6405 17.7751 32.6077 19"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 40.8V42H34V40.8C34 36.3196 34 34.0794 33.1281 32.3681C32.3611 30.8628 31.1372 29.6389 29.6319 28.8719C27.9206 28 25.6804 28 21.2 28H16.8C12.3196 28 10.0794 28 8.36808 28.8719C6.86278 29.6389 5.63893 30.8628 4.87195 32.3681C4 34.0794 4 36.3196 4 40.8Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M43.9999 42.0001V40.8001C43.9999 36.3197 43.9999 34.0795 43.128 32.3682C42.361 30.8629 41.1371 29.6391 39.6318 28.8721"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TrendTwo = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 44H44"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 26L12 28V38H4V26Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      d="M20 24L28 20V38H20V24Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      d="M36 16L44 12V38H36V16Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      d="M4 18L12 20L44 4H34"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const InsertCard = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 18H4L4 6H44V18H38"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 12L4 41H44L36 12H12Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
  </svg>
);

export const Upload = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="icon-3fc9cbed7f10b972"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="48"
      height="48"
      style={{ maskType: 'alpha' }}
    >
      <path d="M48 0H0V48H48V0Z" fill={props.color} />
    </mask>
    <g mask="url(#icon-3fc9cbed7f10b972)">
      <path
        d="M6 24.0083V42H42V24"
        stroke={props.color}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33 15L24 6L15 15"
        stroke={props.color}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.9917 32V6"
        stroke={props.color}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const Up = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 30L25 18L37 30"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Down = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M36 18L24 30L12 18"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Right = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 12L31 24L19 36"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Sort = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24 42L15 29H33L24 42Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      d="M24 6L15 19H33L24 6Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
  </svg>
);

export const Success = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24 4L29.2533 7.83204L35.7557 7.81966L37.7533 14.0077L43.0211 17.8197L41 24L43.0211 30.1803L37.7533 33.9923L35.7557 40.1803L29.2533 40.168L24 44L18.7467 40.168L12.2443 40.1803L10.2467 33.9923L4.97887 30.1803L7 24L4.97887 17.8197L10.2467 14.0077L12.2443 7.81966L18.7467 7.83204L24 4Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 24L22 29L32 19"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TransferData = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 8L4 14L10 20"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M38 28L44 34L38 40"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 14H44"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 34H44"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChangeDestinationCoin = (props) => (
  <svg
    stroke="currentColor"
    fill="none"
    strokeWidth="0"
    viewBox="0 0 24 24"
    height="1em"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.97576 12L4.73312 7.75736L3.31891 9.17157L6.14734 12L3.31891 14.8284L4.73312 16.2426L8.97576 12Z"
      fill="currentColor"
    ></path>
    <path
      d="M11.9998 19C11.4475 19 10.9998 18.5523 10.9998 18V6C10.9998 5.44772 11.4475 5 11.9998 5C12.5521 5 12.9998 5.44772 12.9998 6V18C12.9998 18.5523 12.5521 19 11.9998 19Z"
      fill="currentColor"
    ></path>
    <path
      d="M15.0242 12L19.2669 16.2426L20.6811 14.8284L17.8527 12L20.6811 9.17157L19.2669 7.75736L15.0242 12Z"
      fill="currentColor"
    ></path>
  </svg>
);

export const Help = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24 44C29.5228 44 34.5228 41.7614 38.1421 38.1421C41.7614 34.5228 44 29.5228 44 24C44 18.4772 41.7614 13.4772 38.1421 9.85786C34.5228 6.23858 29.5228 4 24 4C18.4772 4 13.4772 6.23858 9.85786 9.85786C6.23858 13.4772 4 18.4772 4 24C4 29.5228 6.23858 34.5228 9.85786 38.1421C13.4772 41.7614 18.4772 44 24 44Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      d="M24 28.6248V24.6248C27.3137 24.6248 30 21.9385 30 18.6248C30 15.3111 27.3137 12.6248 24 12.6248C20.6863 12.6248 18 15.3111 18 18.6248"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 37.6248C25.3807 37.6248 26.5 36.5055 26.5 35.1248C26.5 33.7441 25.3807 32.6248 24 32.6248C22.6193 32.6248 21.5 33.7441 21.5 35.1248C21.5 36.5055 22.6193 37.6248 24 37.6248Z"
      fill={props.color}
    />
  </svg>
);

export const Undo = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.2721 36.7279C14.5294 39.9853 19.0294 42 24 42C33.9411 42 42 33.9411 42 24C42 14.0589 33.9411 6 24 6C19.0294 6 14.5294 8.01472 11.2721 11.2721C9.61407 12.9301 6 17 6 17"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 9V17H14"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Info = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24 44C29.5228 44 34.5228 41.7614 38.1421 38.1421C41.7614 34.5228 44 29.5228 44 24C44 18.4772 41.7614 13.4772 38.1421 9.85786C34.5228 6.23858 29.5228 4 24 4C18.4772 4 13.4772 6.23858 9.85786 9.85786C6.23858 13.4772 4 18.4772 4 24C4 29.5228 6.23858 34.5228 9.85786 38.1421C13.4772 41.7614 18.4772 44 24 44Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 11C25.3807 11 26.5 12.1193 26.5 13.5C26.5 14.8807 25.3807 16 24 16C22.6193 16 21.5 14.8807 21.5 13.5C21.5 12.1193 22.6193 11 24 11Z"
      fill={props.color}
    />
    <path
      d="M24.5 34V20H23.5H22.5"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 34H28"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Left = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M31 36L19 24L31 12"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const People = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24 20C27.866 20 31 16.866 31 13C31 9.13401 27.866 6 24 6C20.134 6 17 9.13401 17 13C17 16.866 20.134 20 24 20Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 40.8V42H42V40.8C42 36.3196 42 34.0794 41.1281 32.3681C40.3611 30.8628 39.1372 29.6389 37.6319 28.8719C35.9206 28 33.6804 28 29.2 28H18.8C14.3196 28 12.0794 28 10.3681 28.8719C8.86278 29.6389 7.63893 30.8628 6.87195 32.3681C6 34.0794 6 36.3196 6 40.8Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PaymentIcon = (props) => (
  <svg
    width="45"
    height="36"
    viewBox="0 0 45 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.85427 27.8634C7.72455 27.9102 7.58683 27.9306 7.44913 27.9236C7.31143 27.9166 7.17649 27.8823 7.05218 27.8227C6.92787 27.763 6.81667 27.6792 6.72505 27.5762C6.63343 27.4732 6.56322 27.3529 6.51852 27.2225L1.05706 11.6029C0.967408 11.3436 0.983912 11.0594 1.10297 10.8122C1.22202 10.565 1.43399 10.3749 1.69263 10.2834L28.0627 1.05706C28.322 0.967409 28.6063 0.98391 28.8534 1.10297C29.1006 1.22202 29.2907 1.43397 29.3823 1.69261L32.5547 10.7789"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M24.4518 6.80471L22.4485 7.5047C21.7212 7.75883 21.3376 8.55444 21.5917 9.28175L21.8671 10.0699C22.1212 10.7972 22.9169 11.1808 23.6442 10.9266L25.6475 10.2266C26.3748 9.97252 26.7584 9.1769 26.5043 8.44959L26.2289 7.66148C25.9748 6.93417 25.1791 6.55058 24.4518 6.80471Z"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M18.1902 8.85059L18.3948 9.44305"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M15.2278 9.88477L15.4324 10.4772"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M12.2654 10.9189L12.4754 11.5168"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M9.30322 11.9531L9.51327 12.551"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M6.34082 12.9873L6.55087 13.5852"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M42.8312 13.6602L11.409 13.6602C10.7635 13.6602 10.2402 14.1834 10.2402 14.8289L10.2402 33.4593C10.2402 34.1048 10.7635 34.628 11.409 34.628H42.8312C43.4767 34.628 44 34.1048 44 33.4593V14.8289C44 14.1834 43.4767 13.6602 42.8312 13.6602Z"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M10.2402 18.0386H44"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M10.2402 22.5044H40.6553"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M14.9047 31.6873C15.806 31.6873 16.5366 30.9566 16.5366 30.0553C16.5366 29.154 15.806 28.4233 14.9047 28.4233C14.0034 28.4233 13.2727 29.154 13.2727 30.0553C13.2727 30.9566 14.0034 31.6873 14.9047 31.6873Z"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M18.9873 31.6875H20.7486"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M18.9873 28.4233H25.6229"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M23.5547 31.6875H29.8779"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const Minus = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5 24L38.5 24"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Plus = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.0605 10L24.0239 38"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 24L38 24"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Download = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 24.0083V42H42V24"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33 23L24 32L15 23"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.9917 6V32"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CloseSmall = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 14L34 34"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 34L34 14"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CheckSmall = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 24L20 34L40 14"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Attention = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24 44C29.5228 44 34.5228 41.7614 38.1421 38.1421C41.7614 34.5228 44 29.5228 44 24C44 18.4772 41.7614 13.4772 38.1421 9.85786C34.5228 6.23858 29.5228 4 24 4C18.4772 4 13.4772 6.23858 9.85786 9.85786C6.23858 13.4772 4 18.4772 4 24C4 29.5228 6.23858 34.5228 9.85786 38.1421C13.4772 41.7614 18.4772 44 24 44Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 37C25.3807 37 26.5 35.8807 26.5 34.5C26.5 33.1193 25.3807 32 24 32C22.6193 32 21.5 33.1193 21.5 34.5C21.5 35.8807 22.6193 37 24 37Z"
      fill={props.color}
    />
    <path
      d="M24 12V28"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AddOne = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      d="M24 16V32"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 24L32 24"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Logout = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.9917 6H6V42H24"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33 33L42 24L33 15"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 23.9917H42"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Login = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.9917 6H6V42H24"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25 33L16 24L25 15"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M42 23.9917H16"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ListTwo = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 42C11.2091 42 13 40.2091 13 38C13 35.7909 11.2091 34 9 34C6.79086 34 5 35.7909 5 38C5 40.2091 6.79086 42 9 42Z"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      d="M9 14C11.2091 14 13 12.2092 13 10C13 7.79086 11.2091 6 9 6C6.79086 6 5 7.79086 5 10C5 12.2092 6.79086 14 9 14Z"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      d="M9 28C11.2091 28 13 26.2092 13 24C13 21.7908 11.2091 20 9 20C6.79086 20 5 21.7908 5 24C5 26.2092 6.79086 28 9 28Z"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      d="M21 24H43"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 38H43"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 10H43"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Unlink = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.8927 16.0307L18.1145 8.2525C15.2506 5.38866 10.7031 5.29302 7.9572 8.0389C5.21132 10.7848 5.30696 15.3323 8.1708 18.1962L15.949 25.9744"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M31.9161 22.0707L39.6943 29.8489C42.5581 32.7127 42.9291 37.1233 39.9079 40.0062C36.8867 42.8891 32.6144 42.6564 29.7506 39.7926L21.9724 32.0144"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.2384 21.0759L17.3493 17.1868"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30.3131 30.1504L26.424 26.2613"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Filter = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 9L20.4 25.8178V38.4444L27.6 42V25.8178L42 9H6Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
  </svg>
);

export const Edit = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 42H43"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 26.7199V34H18.3172L39 13.3081L31.6951 6L11 26.7199Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
  </svg>
);

export const DownloadFour = (props) => (
  <svg>
    <path
      width="18"
      height="18"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.9999 29.0001L12 17.0001L19.9999 17.0001L19.9999 6.00011L27.9999 6.00011L27.9999 17.0001L35.9999 17.0001L23.9999 29.0001Z"
        fill="none"
        stroke={props.color}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42 37L6 37"
        stroke={props.color}
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M34 44H14"
        stroke={props.color}
        strokeWidth="3"
        strokeLinecap="round"
      />
    </path>
  </svg>
);

export const DeleteFour = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 11L40 11"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 5L30 5"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 17H36V40C36 41.6569 34.6569 43 33 43H15C13.3431 43 12 41.6569 12 40V17Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
  </svg>
);

export const DarkMode = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.0033 4L29.2737 9.27038H38.7296V18.7263L44 23.9967L38.7296 29.2737V38.7296H29.2737L24.0033 44L18.7264 38.7296H9.27036V29.2737L4 23.9967L9.27036 18.7263V9.27038H18.7264L24.0033 4Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27 17C27 25 22 26 17 26C17 30 23.5 34 29 30C34.5 26 31 17 27 17Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CopyLink = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 9.92704V7C12 5.34315 13.3431 4 15 4H41C42.6569 4 44 5.34315 44 7V33C44 34.6569 42.6569 36 41 36H38.0174"
      stroke={props.color}
      strokeWidth="3"
    />
    <rect
      x="4"
      y="10"
      width="34"
      height="34"
      rx="3"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      d="M18.4394 23.1101L23.7319 17.6006C25.1835 16.1489 27.5691 16.1809 29.0602 17.672C30.5513 19.1631 30.5833 21.5487 29.1316 23.0003L27.2215 25.0231"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.4661 28.7472C12.9558 29.2575 11.9006 30.2765 11.9006 30.2765C10.4489 31.7281 10.4095 34.3155 11.9006 35.8066C13.3917 37.2977 15.7772 37.3296 17.2289 35.878L22.3931 31.1896"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.6626 28.3284C17.97 27.6358 17.5922 26.7502 17.5317 25.8548C17.4619 24.8226 17.8138 23.7774 18.5912 23.0001"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.3213 25.8613C23.8124 27.3524 23.8444 29.738 22.3927 31.1896"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Copy = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 12.4316V7.8125C13 6.2592 14.2592 5 15.8125 5H40.1875C41.7408 5 43 6.2592 43 7.8125V32.1875C43 33.7408 41.7408 35 40.1875 35H35.5163"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32.1875 13H7.8125C6.2592 13 5 14.2592 5 15.8125V40.1875C5 41.7408 6.2592 43 7.8125 43H32.1875C33.7408 43 35 41.7408 35 40.1875V15.8125C35 14.2592 33.7408 13 32.1875 13Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
  </svg>
);

export const Calendar = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 19H43V40C43 41.1046 42.1046 42 41 42H7C5.89543 42 5 41.1046 5 40V19Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      d="M5 9C5 7.89543 5.89543 7 7 7H41C42.1046 7 43 7.89543 43 9V19H5V9Z"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      d="M16 4V12"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32 4V12"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28 34H34"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 34H20"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28 26H34"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 26H20"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Time = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      d="M24.0084 12.0001L24.0072 24.0089L32.4866 32.4883"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ConvertIcon = (props) => (
  <svg
    width="32"
    height="37"
    viewBox="0 0 32 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.0099 15H16.3003C16.7511 15 17.1834 15.2107 17.5022 15.5858C17.8209 15.9609 18 16.4696 18 17V17C18 17.5304 17.8209 18.0391 17.5022 18.4142C17.1834 18.7893 16.7511 19 16.3003 19H14V16.4803"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M16.8759 23H14V19H16.8759C17.1548 19 17.431 19.0518 17.6887 19.1523C17.9465 19.2529 18.1806 19.4003 18.3778 19.5862C18.5751 19.772 18.7316 19.9926 18.8383 20.2354C18.945 20.4782 19 20.7385 19 21.0013V21.0013C18.9993 21.5316 18.7752 22.04 18.3769 22.4147C17.9786 22.7895 17.4388 23 16.8759 23V23Z"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M17 14V15"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M15 14V15"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M15 23V24"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M17 23V24"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M10.9216 28.617C8.6508 27.4422 6.84 25.5392 5.77936 23.2128C4.71871 20.8865 4.46962 18.2715 5.07199 15.7867C5.67435 13.3019 7.09331 11.0913 9.10152 9.5089C11.1097 7.92652 13.591 7.064 16.1477 7.05954V8.34043L19.8068 5.19796L16.1349 2V3.28089C12.7452 3.29446 9.45741 4.44099 6.79433 6.53814C4.13126 8.6353 2.24584 11.5627 1.43793 14.8547C0.630024 18.1467 0.946014 21.6143 2.33565 24.7061C3.72529 27.7978 6.10877 30.3362 9.10705 31.9174"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M21.1261 8.37443C23.4009 9.54421 25.217 11.444 26.2832 13.7692C27.3493 16.0944 27.6037 18.7103 27.0055 21.1974C26.4074 23.6844 24.9914 25.8986 22.9846 27.4847C20.9778 29.0709 18.4964 29.9372 15.9385 29.9447V28.6638L12.2751 31.7977L15.9385 35V33.7191C19.3402 33.7211 22.6442 32.5813 25.3211 30.4824C27.9981 28.3834 29.8931 25.4468 30.7026 22.1428C31.5121 18.8388 31.1892 15.3587 29.7858 12.26C28.3823 9.16132 25.9794 6.62335 22.9621 5.05264"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const TradeIcon = (props) => (
  <svg
    width={props.width || '39'}
    height={props.height || '39'}
    viewBox="0 0 39 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.3668 13.4448H20.1533C20.8986 13.4448 21.6134 13.7409 22.1404 14.2679C22.6674 14.7949 22.9634 15.5097 22.9634 16.255V16.255C22.9634 17.0003 22.6674 17.7151 22.1404 18.2421C21.6134 18.7691 20.8986 19.0651 20.1533 19.0651H16.3503V15.5248"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M20.7768 25.5755H16.3667V19.0649H20.7768C21.2046 19.0649 21.6281 19.1492 22.0233 19.3129C22.4185 19.4766 22.7776 19.7165 23.08 20.019C23.3825 20.3215 23.6225 20.6805 23.7862 21.0757C23.9498 21.4709 24.0341 21.8945 24.0341 22.3223V22.3223C24.033 23.1854 23.6894 24.0129 23.0786 24.6229C22.4679 25.2329 21.64 25.5755 20.7768 25.5755V25.5755Z"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M28.6289 12.5626C30.4082 14.8877 31.2325 17.8044 30.9335 20.7168C30.6344 23.6292 29.2345 26.3176 27.0198 28.2325C24.8052 30.1474 21.9429 31.1444 19.0178 31.0198C16.0927 30.8952 13.3256 29.6583 11.2818 27.5619C9.23809 25.4655 8.07196 22.6679 8.02171 19.7405C7.97147 16.8132 9.04091 13.9772 11.0115 11.8119C12.9821 9.64666 15.7052 8.31556 18.6242 8.09062C21.5433 7.86567 24.4381 8.76386 26.7172 10.6017"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M25.9991 32.5009C33.1793 28.9116 36.0903 20.1811 32.501 13.0009C28.9116 5.82068 20.1812 2.90967 13.001 6.499C5.82074 10.0883 2.90972 18.8188 6.49904 25.999C10.0884 33.1792 18.8188 36.0902 25.9991 32.5009Z"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const Contrast = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      d="M24 36V12C17.3726 12 12 17.3726 12 24C12 30.6274 17.3726 36 24 36Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
  </svg>
);

export const LinkThree = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="34.6074"
      y="3.4939"
      width="14"
      height="18"
      rx="2"
      transform="rotate(45 34.6074 3.4939)"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <rect
      x="16.2227"
      y="21.8787"
      width="14"
      height="18"
      rx="2"
      transform="rotate(45 16.2227 21.8787)"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      d="M31.0723 16.929L16.9301 31.0711"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ScanCode = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 15V6H15"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 42H6V33"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M42 33V42H33"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33 6H42V15"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 24H38"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const History = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.81836 6.72729V14H13.0911"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 24C4 35.0457 12.9543 44 24 44V44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C16.598 4 10.1351 8.02111 6.67677 13.9981"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.005 12L24.0038 24.0088L32.4832 32.4882"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Bookmark = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 44C8.89543 44 8 43.1046 8 42V6C8 4.89543 8.89543 4 10 4H38C39.1046 4 40 4.89543 40 6V42C40 43.1046 39.1046 44 38 44H10Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 22V4H33V22L27 15.7273L21 22Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 4H38"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const StockMarket = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="6"
      y="20"
      width="8"
      height="14"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <rect
      x="20"
      y="14"
      width="8"
      height="26"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      d="M24 44V40"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="34"
      y="12"
      width="8"
      height="9"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      d="M10 20V10"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M38 34V21"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M38 12V4"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Wallet = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.982 11.9689L31.7846 4L36.397 11.9889L17.982 11.9689Z"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 14C4 12.8954 4.89543 12 6 12H42C43.1046 12 44 12.8954 44 14V42C44 43.1046 43.1046 44 42 44H6C4.89543 44 4 43.1046 4 42V14Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      d="M35.25 33H44V23H35.25C32.3505 23 30 25.2386 30 28C30 30.7614 32.3505 33 35.25 33Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      d="M44 16.5V40.5"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
    />
  </svg>
);

export const IosShare = (props) => (
  <svg
    width="26"
    height="35"
    viewBox="0 0 26 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.3 8.1L13 2.8L7.69999 8.1L6.29999 6.7L13 0L19.7 6.7L18.3 8.1Z"
      fill={props?.color}
    />
    <path d="M12 1.3999H14V22.3999H12V1.3999Z" fill={props?.color} />
    <path
      d="M23 34.3999H3C1.3 34.3999 0 33.0999 0 31.3999V13.3999C0 11.6999 1.3 10.3999 3 10.3999H10V12.3999H3C2.4 12.3999 2 12.7999 2 13.3999V31.3999C2 31.9999 2.4 32.3999 3 32.3999H23C23.6 32.3999 24 31.9999 24 31.3999V13.3999C24 12.7999 23.6 12.3999 23 12.3999H16V10.3999H23C24.7 10.3999 26 11.6999 26 13.3999V31.3999C26 33.0999 24.7 34.3999 23 34.3999Z"
      fill={props?.color}
    />
  </svg>
);

export const Me = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24 23C26.7614 23 29 20.7614 29 18C29 15.2386 26.7614 13 24 13C21.2386 13 19 15.2386 19 18C19 20.7614 21.2386 23 24 23Z"
      fill="none"
      stroke={props.color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      d="M10.022 38.332C10.3657 33.1206 14.7016 29 20 29H28C33.2914 29 37.6229 33.1097 37.9767 38.3113"
      stroke={props.color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FancyTrade = (props) => (
  <svg viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.4915 8.61865H12.9187C13.3965 8.61865 13.8547 8.80844 14.1925 9.14626C14.5303 9.48409 14.7201 9.94228 14.7201 10.42V10.42C14.7201 10.8978 14.5303 11.356 14.1925 11.6938C13.8547 12.0316 13.3965 12.2214 12.9187 12.2214H10.481V9.95194"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M13.3184 16.3936H10.4915V12.2202H13.3184C13.5926 12.2202 13.8642 12.2742 14.1175 12.3792C14.3708 12.4841 14.601 12.6379 14.7949 12.8318C14.9888 13.0257 15.1426 13.2559 15.2475 13.5092C15.3524 13.7625 15.4065 14.034 15.4065 14.3082V14.3082C15.4058 14.8616 15.1855 15.392 14.794 15.783C14.4025 16.174 13.8718 16.3936 13.3184 16.3936V16.3936Z"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M10.4914 8.61865H9.59204"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M10.4914 16.3945H9.59204"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M11.4355 7.80811V8.61807"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M13.0898 7.80811V8.61807"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M11.4355 16.3945V17.2071"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M13.0896 16.3945V17.2071"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M18.3517 8.05299C19.4923 9.54342 20.0207 11.4131 19.829 13.28C19.6373 15.147 18.7399 16.8703 17.3202 18.0978C15.9006 19.3253 14.0658 19.9644 12.1907 19.8845C10.3157 19.8046 8.54187 19.0118 7.23178 17.6679C5.92168 16.3241 5.17416 14.5307 5.14195 12.6542C5.10975 10.7778 5.79529 8.95979 7.05849 7.57179C8.3217 6.18379 10.0672 5.33053 11.9385 5.18633C13.8097 5.04214 15.6653 5.6179 17.1263 6.79597"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M16.6661 20.8339C21.2688 18.533 23.1348 12.9366 20.8339 8.33386C18.5331 3.73115 12.9367 1.86512 8.33396 4.16597C3.73125 6.46682 1.8652 12.0633 4.16605 16.666C6.4669 21.2687 12.0634 23.1347 16.6661 20.8339Z"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const FancyHome = (props) => (
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.3334 16.6667V10.145C18.3335 9.69131 18.2409 9.24235 18.0613 8.82566C17.8818 8.40896 17.6191 8.03331 17.2893 7.72171L11.1451 1.91504C10.8356 1.62248 10.4259 1.45947 10.0001 1.45947C9.57423 1.45947 9.16453 1.62248 8.85508 1.91504L2.71091 7.72171C2.3811 8.03331 2.11838 8.40896 1.93883 8.82566C1.75928 9.24235 1.6667 9.69131 1.66675 10.145V16.6667C1.66675 17.1087 1.84234 17.5327 2.1549 17.8452C2.46746 18.1578 2.89139 18.3334 3.33342 18.3334H16.6668C17.1088 18.3334 17.5327 18.1578 17.8453 17.8452C18.1578 17.5327 18.3334 17.1087 18.3334 16.6667Z"
      stroke={props.color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.34062 8.90088H10.0397C10.3741 8.90088 10.6949 9.03373 10.9313 9.27021C11.1678 9.50668 11.3007 9.82742 11.3007 10.1618V10.1618C11.3007 10.4963 11.1678 10.817 10.9313 11.0535C10.6949 11.29 10.3741 11.4228 10.0397 11.4228H8.33325V9.83418"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M10.3195 14.3438H8.34058V11.4224H10.3195C10.5114 11.4224 10.7015 11.4602 10.8788 11.5336C11.0561 11.6071 11.2173 11.7147 11.353 11.8505C11.4887 11.9862 11.5964 12.1473 11.6698 12.3246C11.7433 12.502 11.7811 12.692 11.7811 12.884V12.884C11.7806 13.2713 11.6264 13.6426 11.3523 13.9163C11.0783 14.19 10.7068 14.3438 10.3195 14.3438V14.3438Z"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M9.00146 8.3335V8.90047"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M10.1594 8.3335V8.90047"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M9.00146 14.3438V14.9126"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M10.1594 14.3438V14.9126"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const FancyMarket = (props) => (
  <svg viewBox="0 0 28 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M28 18H1V0" stroke={props.color} strokeMiterlimit="10" />
    <path
      d="M25.1915 3.29096V1.35303H23.3145"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M2.67407 14.6562L12.034 4.97394L16.8789 9.98185L24.6843 1.90771"
      stroke={props.color}
      strokeMiterlimit="10"
    />
    <path
      d="M4.70337 15.4888V16.096"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M7.14941 13.397V16.0958"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M9.5918 10.8179V16.0957"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M12.0342 8.62842V16.0953"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M14.48 10.8179V16.0957"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M16.9224 12.4673V16.0958"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M19.3647 10.8179V16.0957"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M21.8108 8.62842V16.0953"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M24.2532 5.88135V16.0958"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const FancyWallet = (props) => (
  <svg viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.85425 6.24121H4.19435"
      stroke={props.color}
      strokeMiterlimit="10"
    />
    <path
      d="M5.50073 6.24121H6.84084"
      stroke={props.color}
      strokeMiterlimit="10"
    />
    <path
      d="M8.14722 6.24121H9.48732"
      stroke={props.color}
      strokeMiterlimit="10"
    />
    <path
      d="M10.7937 6.24121H12.1338"
      stroke={props.color}
      strokeMiterlimit="10"
    />
    <path
      d="M13.4404 6.24121H14.7805"
      stroke={props.color}
      strokeMiterlimit="10"
    />
    <path
      d="M16.0869 6.24121H17.427"
      stroke={props.color}
      strokeMiterlimit="10"
    />
    <path
      d="M2.85425 16.7202H4.19435"
      stroke={props.color}
      strokeMiterlimit="10"
    />
    <path
      d="M5.50073 16.7202H6.84084"
      stroke={props.color}
      strokeMiterlimit="10"
    />
    <path
      d="M8.14722 16.7202H9.48732"
      stroke={props.color}
      strokeMiterlimit="10"
    />
    <path
      d="M10.7937 16.7202H12.1338"
      stroke={props.color}
      strokeMiterlimit="10"
    />
    <path
      d="M13.4404 16.7202H14.7805"
      stroke={props.color}
      strokeMiterlimit="10"
    />
    <path
      d="M16.0869 16.7202H17.427"
      stroke={props.color}
      strokeMiterlimit="10"
    />
    <path
      d="M16.4404 11.482C16.4404 11.5042 16.4338 11.5258 16.4215 11.5442L16.8373 11.822L16.4215 11.5442C16.4092 11.5626 16.3917 11.577 16.3713 11.5854C16.3508 11.5939 16.3283 11.5961 16.3066 11.5918C16.2849 11.5875 16.265 11.5768 16.2493 11.5612L15.8958 11.9147L16.2493 11.5612C16.2337 11.5455 16.223 11.5256 16.2187 11.5039C16.2144 11.4822 16.2166 11.4596 16.2251 11.4392C16.2335 11.4188 16.2479 11.4013 16.2663 11.389C16.2847 11.3767 16.3063 11.3701 16.3285 11.3701C16.3581 11.3701 16.3866 11.3819 16.4076 11.4029C16.4286 11.4239 16.4404 11.4524 16.4404 11.482Z"
      fill={props.color}
      stroke={props.color}
    />
    <path
      d="M19.2811 14.7898V17.3079C19.2815 17.5121 19.2416 17.7144 19.1636 17.9032C19.0856 18.0919 18.9712 18.2634 18.8268 18.4078C18.6823 18.5522 18.5108 18.6667 18.3221 18.7447C18.1333 18.8226 17.931 18.8626 17.7268 18.8622H1V4.09961H17.7268C17.931 4.09921 18.1333 4.13913 18.3221 4.2171C18.5108 4.29507 18.6823 4.40954 18.8268 4.55395C18.9712 4.69836 19.0856 4.86986 19.1636 5.05861C19.2416 5.24737 19.2815 5.44966 19.2811 5.65389V9.75987"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M14.2175 9.90967H19.7248C19.8473 9.90967 19.9648 9.95834 20.0515 10.045C20.1381 10.1316 20.1868 10.2491 20.1868 10.3717V12.5868C20.1868 12.7093 20.1381 12.8269 20.0515 12.9135C19.9648 13.0001 19.8473 13.0488 19.7248 13.0488H14.2175V9.90967Z"
      stroke={props.color}
      strokeMiterlimit="10"
    />
    <path
      d="M17.8584 2.54816V1H2.3707C2.0077 0.999999 1.65952 1.14399 1.40255 1.40039C1.14558 1.65678 1.00081 2.00464 1 2.36764V4.09631"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M2.854 2.54785H16.0439"
      stroke={props.color}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const NightsStay = (props) => (
  <svg
    class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-dhaba5"
    focusable="false"
    aria-hidden="true"
    viewBox="0 0 24 24"
    data-testid="NightsStayIcon"
    style={{ width: "18px" }}
  >
    <path d="M11.1 12.08c-2.33-4.51-.5-8.48.53-10.07C6.27 2.2 1.98 6.59 1.98 12c0 .14.02.28.02.42.62-.27 1.29-.42 2-.42 1.66 0 3.18.83 4.1 2.15 1.67.48 2.9 2.02 2.9 3.85 0 1.52-.87 2.83-2.12 3.51.98.32 2.03.5 3.11.5 3.5 0 6.58-1.8 8.37-4.52-2.36.23-6.98-.97-9.26-5.41"></path>
    <path d="M7 16h-.18C6.4 14.84 5.3 14 4 14c-1.66 0-3 1.34-3 3s1.34 3 3 3h3c1.1 0 2-.9 2-2s-.9-2-2-2"></path>
  </svg>
);

export const ThemeIcon = (props) => (
  <svg width="18" height="18" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24 40.9444C26.123 42.8446 28.9266 44 32 44C38.6274 44 44 38.6274 44 32C44 26.4085 40.1757 21.7102 35 20.3781" stroke={props?.color || "#333"} stroke-width="2" stroke-linejoin="round" /><path d="M13 20.3781C7.82432 21.7102 4 26.4085 4 32C4 38.6274 9.37258 44 16 44C22.6274 44 28 38.6274 28 32C28 30.4506 27.7063 28.9697 27.1716 27.6101" stroke={props?.color || "#333"} stroke-width="2" stroke-linejoin="round" /><path d="M24 28C30.6274 28 36 22.6274 36 16C36 9.37258 30.6274 4 24 4C17.3726 4 12 9.37258 12 16C12 22.6274 17.3726 28 24 28Z" fill={props?.color || "#333"} stroke={props?.color || "#333"} stroke-width="2" stroke-linejoin="round" /></svg>
);

export const SanaCashNewLogoPrimary = (props) => (
  <svg width="113" height="131" viewBox="0 0 113 131" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M83.7599 80.36C83.7599 80.36 83.6699 80.44 83.6299 80.48L83.7599 80.55V80.36Z" fill="#404041" />
    <path d="M13.72 56.51V40.44L56.31 15.85V0L0 32.52V48.62V60.24V64.01L56.31 96.4V81.01L13.72 56.51Z" fill="#22376D" />
    <path d="M56.3101 81.01V96.4L83.2601 80.84C83.3801 80.73 83.5 80.61 83.64 80.48L70.4401 72.86L56.3101 81.02V81.01ZM56.3101 0V15.85L98.9 40.44V50.12L112.62 57.97V32.51L56.3101 0Z" fill="#21468B" />
    <path d="M13.72 89.6201V79.82L0 71.92V97.54L56.31 130.05V114.2L13.72 89.6201Z" fill="#21468B" />
    <path d="M29.3602 49.21C29.2402 49.32 29.1202 49.44 28.9902 49.57L42.1902 57.19L56.3203 49.03V33.64L29.3702 49.2L29.3602 49.21Z" fill="#21468B" />
    <path d="M112.62 65.88L56.3101 33.65V49.04L98.9 73.41V89.62L56.3101 114.2V130.05L112.62 97.54V65.88Z" fill="#22376D" />
  </svg>
);

export const SanaCashNewLogoSecondary = (props) => (
  <svg width="113" height="131" viewBox="0 0 113 131" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M83.7701 80.36C83.7701 80.36 83.6801 80.44 83.6401 80.48L83.7701 80.55V80.36Z" fill="white" />
    <path d="M13.73 56.51V40.44L56.31 15.85V0L0 32.52V48.62V60.24V64L56.31 96.4V81.01L13.73 56.51Z" fill="#D4D7DA" />
    <path d="M56.3101 81.01V96.4L83.2601 80.84C83.3801 80.73 83.5 80.61 83.64 80.48L70.44 72.86L56.3101 81.02V81.01ZM56.3101 0V15.85L98.9001 40.44V50.12L112.62 57.97V32.51L56.3101 0Z" fill="white" />
    <path d="M13.73 89.61V79.82L0 71.92V97.54L56.31 130.05V114.2L13.73 89.61Z" fill="#D4D7DA" />
    <path d="M29.3602 49.21C29.2402 49.32 29.1202 49.44 28.9902 49.57L42.1902 57.19L56.3202 49.03V33.64L29.3702 49.2L29.3602 49.21Z" fill="#D4D7DA" />
    <path d="M112.62 65.88L56.3101 33.65V49.04L98.9001 73.41V89.61L56.3101 114.2V130.05L112.62 97.54V65.88Z" fill="white" />
  </svg>
);

export const SanaCashTypographyLogo = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 677.18 83.16"><defs></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="cls-1" d="M605.71,83h-3.37V0h3.37a5.73,5.73,0,0,1,5.73,5.73V77.31A5.73,5.73,0,0,1,605.71,83Z" /><path class="cls-1" d="M668.08,5.85V31.23H623.47v3.36a5.73,5.73,0,0,0,5.73,5.73h38.88V77.4a5.73,5.73,0,0,0,5.73,5.72h3.37V.12h-3.37A5.74,5.74,0,0,0,668.08,5.85Z" /><path class="cls-1" d="M235.67,83V.12H232.3a5.73,5.73,0,0,0-5.73,5.72V71.78L172.23.12H162V45.83h3.37a5.74,5.74,0,0,0,5.73-5.73V13.63L223.71,83Z" /><path class="cls-1" d="M463.09.12h-2.75a5.73,5.73,0,0,0-5.07,3.06L413.32,83h10.27l38.13-72.58L495.07,74h-44.5a5.73,5.73,0,0,0-5.73,5.73V83h65.27L468.16,3.18A5.73,5.73,0,0,0,463.09.12Z" /><path class="cls-1" d="M291.37.12h-2.75a5.73,5.73,0,0,0-5.07,3.06L241.6,83h10.27L290,10.46,323.35,74h-44.5a5.73,5.73,0,0,0-5.73,5.73V83h65.27L296.44,3.18A5.73,5.73,0,0,0,291.37.12Z" /><path class="cls-1" d="M123.67.12h-2.75a5.73,5.73,0,0,0-5.07,3.06L73.9,83H84.17L122.3,10.46,155.65,74h-44.5a5.73,5.73,0,0,0-5.73,5.73V83h65.27L128.74,3.18A5.73,5.73,0,0,0,123.67.12Z" /><path class="cls-1" d="M406.81,83.16H372.6c-22.52,0-41.72-17.48-42.58-40A41.64,41.64,0,0,1,371.58,0h35.23V3.36a5.73,5.73,0,0,1-5.73,5.73H372.52C355,9.09,340,22.49,339.13,39.94a32.52,32.52,0,0,0,32.45,34.13h29.5a5.73,5.73,0,0,1,5.73,5.72Z" /><path class="cls-1" d="M549.48,46.17c-.63,0-11.35,0-12-.09a17.31,17.31,0,0,1-1.78-.22.72.72,0,0,1-.22,0,12.51,12.51,0,0,1-1.46-.28l-.38-.1a15.06,15.06,0,0,1-1.49-.45,14.29,14.29,0,0,1-1.54-.58,1.67,1.67,0,0,1-.4-.16,4.62,4.62,0,0,1-.81-.39,7.32,7.32,0,0,1-1-.52c-.42-.22-.85-.48-1.26-.73s-1.22-.82-1.66-1.16-.68-.53-1-.82-.79-.69-1.17-1.07a12.66,12.66,0,0,1-1.07-1.13A16.11,16.11,0,0,1,521,37a12.29,12.29,0,0,1-.78-1.11,13.19,13.19,0,0,1-.83-1.35c-.26-.47-.53-.93-.75-1.41a.11.11,0,0,1,0-.07,22.65,22.65,0,0,1-2.26-9.89v-.51c0-.42,0-.79.06-1.15s.06-.75.1-1.11A23,23,0,0,1,539.38.16h49.78V3.53a5.74,5.74,0,0,1-5.73,5.73h-44a13.92,13.92,0,0,0-13.9,13.9,11.21,11.21,0,0,0,.08,1.41,8.09,8.09,0,0,0,.14,1,11.42,11.42,0,0,0,.26,1.19c.11.39.21.73.33,1.07a1.22,1.22,0,0,0,.1.24,7.24,7.24,0,0,0,.38.95l.06.13a6.4,6.4,0,0,0,.43.82,6,6,0,0,0,.48.81,13.47,13.47,0,0,0,4.12,4.08,6,6,0,0,0,.71.45,4.71,4.71,0,0,0,.59.32l.4.18c.28.14.59.26.89.39l.16.06c.28.1.59.2.89.28a11.5,11.5,0,0,0,1.19.3A12.52,12.52,0,0,0,538,37c.47.06,11,.08,11.52.08" /><path class="cls-1" d="M558.2,37.39c.08,0,10.53,0,10.59,0,.49.06,5.54.16,6,.28l.38.1a15.25,15.25,0,0,1,1.5.45,14.13,14.13,0,0,1,1.53.58,1.74,1.74,0,0,1,.41.16,5.42,5.42,0,0,1,.81.39,7.87,7.87,0,0,1,1,.52c.42.22.84.48,1.25.74s1.22.81,1.66,1.15.68.53,1,.82.78.69,1.17,1.07.72.73,1.07,1.13a16,16,0,0,1,1.17,1.44c.28.36.54.72.79,1.11s.56.89.83,1.35.52.93.74,1.42a.07.07,0,0,1,0,.06,22.53,22.53,0,0,1,2.27,9.9v.5c0,.42,0,.79-.06,1.15s-.07.75-.11,1.11a23,23,0,0,1-22.82,20.23h-53.1V79.72A5.73,5.73,0,0,1,522.12,74h47.37a13.93,13.93,0,0,0,13.9-13.89,11.28,11.28,0,0,0-.09-1.42,8.09,8.09,0,0,0-.14-1,11.42,11.42,0,0,0-.26-1.19c-.1-.38-.2-.73-.32-1.07a1.22,1.22,0,0,0-.1-.24,9,9,0,0,0-.39-1l-.06-.12a5.87,5.87,0,0,0-.42-.83,6,6,0,0,0-.49-.81A13.37,13.37,0,0,0,577,48.42a4.73,4.73,0,0,0-.71-.45,5.39,5.39,0,0,0-.58-.32l-.41-.18c-.28-.14-.58-.26-.88-.39l-.17-.06c-.28-.1-15.52-.2-15.83-.28" /><path class="cls-1" d="M33.09,46.17c-.62,0-11.35,0-12-.09a17.66,17.66,0,0,1-1.78-.22.72.72,0,0,1-.22,0,12.35,12.35,0,0,1-1.45-.28l-.39-.1A15.06,15.06,0,0,1,15.78,45a14.29,14.29,0,0,1-1.54-.58,1.67,1.67,0,0,1-.4-.16,5,5,0,0,1-.81-.39,7.32,7.32,0,0,1-1-.52c-.42-.22-.85-.48-1.25-.73s-1.22-.82-1.67-1.16-.67-.53-1-.82-.79-.69-1.17-1.07a14.29,14.29,0,0,1-1.07-1.13A14.44,14.44,0,0,1,4.65,37a10.65,10.65,0,0,1-.79-1.11A15.22,15.22,0,0,1,3,34.53c-.26-.47-.52-.93-.75-1.41a.11.11,0,0,1,0-.07A22.65,22.65,0,0,1,0,23.16v-.51c0-.42,0-.79.06-1.15s.06-.75.1-1.11A23,23,0,0,1,23,.16H72.77V3.53A5.73,5.73,0,0,1,67,9.26H23a13.92,13.92,0,0,0-13.9,13.9,11.21,11.21,0,0,0,.08,1.41,8.09,8.09,0,0,0,.14,1,9.34,9.34,0,0,0,.27,1.19c.1.39.2.73.32,1.07A1.22,1.22,0,0,0,10,28a7.24,7.24,0,0,0,.38.95l.06.13a8,8,0,0,0,.43.82,6,6,0,0,0,.48.81,13.47,13.47,0,0,0,4.12,4.08,6,6,0,0,0,.71.45,5.54,5.54,0,0,0,.59.32l.4.18c.28.14.59.26.89.39l.16.06c.29.1.59.2.89.28a12.18,12.18,0,0,0,1.19.3,12.33,12.33,0,0,0,1.28.18c.46.06,11,.08,11.51.08" /><path class="cls-1" d="M41.81,37.39c.08,0,10.53,0,10.59,0,.49.06,5.55.16,6,.28l.38.1a15.25,15.25,0,0,1,1.5.45,14.29,14.29,0,0,1,1.54.58,1.67,1.67,0,0,1,.4.16,5.42,5.42,0,0,1,.81.39,7.87,7.87,0,0,1,1,.52c.42.22.84.48,1.25.74s1.22.81,1.67,1.15.67.53,1,.82.79.69,1.17,1.07a14.29,14.29,0,0,1,1.07,1.13,16,16,0,0,1,1.17,1.44,12.39,12.39,0,0,1,.79,1.11,15.22,15.22,0,0,1,.83,1.35c.26.47.52.93.75,1.42a.07.07,0,0,1,0,.06,22.66,22.66,0,0,1,2.26,9.9v.5c0,.42,0,.79-.06,1.15s-.06.75-.1,1.11A23,23,0,0,1,53.1,83.09H0V79.72A5.73,5.73,0,0,1,5.73,74H53.1A13.93,13.93,0,0,0,67,60.1a11.27,11.27,0,0,0-.08-1.42,6.51,6.51,0,0,0-.15-1,11.42,11.42,0,0,0-.26-1.19c-.1-.38-.2-.73-.32-1.07a1.22,1.22,0,0,0-.1-.24,6.11,6.11,0,0,0-.39-1l-.06-.12a5.87,5.87,0,0,0-.42-.83,5.13,5.13,0,0,0-.49-.81,13.37,13.37,0,0,0-4.12-4.08,5.2,5.2,0,0,0-.7-.45c-.19-.12-.39-.22-.59-.32l-.4-.18c-.29-.14-.59-.26-.89-.39L57.87,47c-.29-.1-15.53-.2-15.83-.28" /></g></g></svg>
);

export const EyeIcon = (props) => (
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.3335 8.50001C1.3335 8.50001 3.3335 3.83334 8.00016 3.83334C12.6668 3.83334 14.6668 8.50001 14.6668 8.50001C14.6668 8.50001 12.6668 13.1667 8.00016 13.1667C3.3335 13.1667 1.3335 8.50001 1.3335 8.50001Z" stroke={props?.color || "white"} stroke-linecap="round" stroke-linejoin="round" />
    <path d="M8 10.5C9.10457 10.5 10 9.60457 10 8.5C10 7.39543 9.10457 6.5 8 6.5C6.89543 6.5 6 7.39543 6 8.5C6 9.60457 6.89543 10.5 8 10.5Z" stroke={props?.color || "white"} stroke-linecap="round" stroke-linejoin="round" />
  </svg>
)

export const EyeOffIcon = (props) => (
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.58675 7.08667C6.39025 7.26977 6.23265 7.49057 6.12334 7.7359C6.01402 7.98123 5.95524 8.24607 5.95051 8.51461C5.94577 8.78315 5.99517 9.04989 6.09576 9.29893C6.19635 9.54796 6.34607 9.77419 6.53598 9.96411C6.7259 10.154 6.95212 10.3037 7.20116 10.4043C7.45019 10.5049 7.71694 10.5543 7.98548 10.5496C8.25402 10.5448 8.51885 10.4861 8.76419 10.3768C9.00952 10.2674 9.23032 10.1098 9.41342 9.91334" stroke={props?.color || "white"} stroke-linecap="round" stroke-linejoin="round" />
    <path d="M7.15332 3.88668C7.43419 3.85168 7.71694 3.83387 7.99999 3.83334C12.6667 3.83334 14.6667 8.50001 14.6667 8.50001C14.3686 9.13809 13.9948 9.73797 13.5533 10.2867" stroke={props?.color || "white"} stroke-linecap="round" stroke-linejoin="round" />
    <path d="M4.40683 4.90668C3.081 5.80976 2.02008 7.05018 1.3335 8.50001C1.3335 8.50001 3.3335 13.1667 8.00016 13.1667C9.27744 13.1701 10.5274 12.7967 11.5935 12.0933" stroke={props?.color || "white"} stroke-linecap="round" stroke-linejoin="round" />
    <path d="M1.3335 1.83334L14.6668 15.1667" stroke={props?.color || "white"} stroke-linecap="round" stroke-linejoin="round" />
  </svg>
)

export const SuccessCheckIcon = (props) => (
  <svg width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M31 3.5C46.1878 3.5 58.5 15.8122 58.5 31C58.5 46.1878 46.1878 58.5 31 58.5C15.8122 58.5 3.5 46.1878 3.5 31C3.5 15.8122 15.8122 3.5 31 3.5Z" fill={props?.fill || "#26A17B60"} />
    <path d="M31 3.5C46.1878 3.5 58.5 15.8122 58.5 31C58.5 46.1878 46.1878 58.5 31 58.5C15.8122 58.5 3.5 46.1878 3.5 31C3.5 15.8122 15.8122 3.5 31 3.5Z" stroke={props?.stroke || "#F0FDFA"} stroke-width="7" />
    <g clip-path="url(#clip0_3409_2476)">
      <path d="M41 30.08V31C40.9988 33.1564 40.3005 35.2547 39.0093 36.9818C37.7182 38.709 35.9033 39.9725 33.8354 40.5839C31.7674 41.1953 29.5573 41.1219 27.5345 40.3746C25.5117 39.6273 23.7847 38.2461 22.611 36.4371C21.4373 34.628 20.8798 32.4881 21.0217 30.3363C21.1636 28.1846 21.9972 26.1363 23.3983 24.4971C24.7994 22.8578 26.6928 21.7154 28.7962 21.2401C30.8996 20.7649 33.1003 20.9823 35.07 21.86" stroke="#26A17B" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M41 23L31 33.01L28 30.01" stroke="#26A17B" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_3409_2476">
        <rect width="24" height="24" fill="white" transform="translate(19 19)" />
      </clipPath>
    </defs>
  </svg>
)

export const GaugeIcon = (props) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 10.5L12 7.5" stroke={props?.color || "#FFCD43"} stroke-linecap="round" stroke-linejoin="round" />
    <path d="M2.505 14.25C1.84666 13.1099 1.50005 11.8165 1.5 10.5C1.49995 9.18342 1.84646 7.89005 2.50471 6.74986C3.16296 5.60967 4.10975 4.66284 5.24992 4.00455C6.39008 3.34626 7.68344 2.99969 9 2.99969C10.3166 2.99969 11.6099 3.34626 12.7501 4.00455C13.8902 4.66284 14.837 5.60967 15.4953 6.74986C16.1535 7.89005 16.5001 9.18342 16.5 10.5C16.4999 11.8165 16.1533 13.1099 15.495 14.25" stroke={props?.color || "#FFCD43"} stroke-linecap="round" stroke-linejoin="round" />
  </svg>
)

export const TooltipIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke={props?.color || "#6B7280"} stroke-linecap="round" stroke-linejoin="round" />
    <path d="M12 16V12" stroke={props?.color || "#6B7280"} stroke-linecap="round" stroke-linejoin="round" />
    <path d="M12 8H12.01" stroke={props?.color || "#6B7280"} stroke-linecap="round" stroke-linejoin="round" />
  </svg>
)